// Header JavaScript
// Burger menu functionality is handled by drawer-element component

document.addEventListener("DOMContentLoaded", function () {
  // Close drawer on window resize if screen becomes larger than mobile breakpoint
  window.addEventListener("resize", function () {
    if (window.innerWidth > 990) {
      const mobileMenu = document.getElementById("mobile-menu");
      if (mobileMenu?.hasAttribute("open")) {
        window.dispatchEvent(new Event("close-drawer-mobile-menu"));
      }
    }
  });
});
